export default __webpack_public_path__ + "static/media/29b07bf4a4a1cd308a2f23e9601e52141640099974202.1fbefda2.webp";